import { useState, useCallback } from 'react';

const useCreateResume = () => {
    const [step, setStep] = useState(1);
    const [showDownloadLink, setShowDownloadLink] = useState(false);
    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState({
        dadosPessoais: {
            nome: '',
            email: '',
            telefone: '',
            municipio: '',
            bairro: '',
            sobreMim: '',
            redesSociais: {
                instagram: '',
                x: '',
                threads: '',
                facebook: '',
                linkedin: '',
                github: ''
            }
        },
        experiencia: [],
        formacao: [],
    });

    // --- MANIPULAÇÃO DE DADOS ---
    const handleChange = useCallback((event) => {
        const { name, value, dataset } = event.target;
        const { section } = dataset;
        setFormData(prevState => ({
            ...prevState,
            [section]: {
                ...prevState[section],
                [name]: value
            }
        }));
    }, []);

    const handleRedesSociaisChange = useCallback((event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            dadosPessoais: {
                ...prevState.dadosPessoais,
                redesSociais: {
                    ...prevState.dadosPessoais.redesSociais,
                    [name]: value
                }
            }
        }));
    }, []);

    // --- FORMAÇÃO ---
    const addFormacao = useCallback(() => {
        const newFormacao = { id: Date.now(), instituicao: '', curso: '', inicio_form: '', fim_form: '' };
        setFormData(prevState => ({ ...prevState, formacao: [...prevState.formacao, newFormacao] }));
    }, []);

    const removeFormacao = useCallback((id) => {
        setFormData(prevState => ({ ...prevState, formacao: prevState.formacao.filter(item => item.id !== id) }));
    }, []);

    const handleFormacaoChange = useCallback((index, event) => {
        const { name, value } = event.target;
        setFormData(prevState => {
            const newFormacaoArray = [...prevState.formacao];
            newFormacaoArray[index] = { ...newFormacaoArray[index], [name]: value };
            return { ...prevState, formacao: newFormacaoArray };
        });
    }, []);

    // --- EXPERIÊNCIA ---
    const addExperiencia = useCallback(() => {
        const newExperiencia = { id: Date.now(), empresa: '', cargo: '', inicio_exp: '', fim_exp: '', descricao_exp: '' };
        setFormData(prevState => ({ ...prevState, experiencia: [...prevState.experiencia, newExperiencia] }));
    }, []);

    const removeExperiencia = useCallback((id) => {
        setFormData(prevState => ({ ...prevState, experiencia: prevState.experiencia.filter(item => item.id !== id) }));
    }, []);

    const handleExperienciaChange = useCallback((index, event) => {
        const { name, value } = event.target;
        setFormData(prevState => {
            const newExperienciaArray = [...prevState.experiencia];
            newExperienciaArray[index] = { ...newExperienciaArray[index], [name]: value };
            return { ...prevState, experiencia: newExperienciaArray };
        });
    }, []);

    // --- NAVEGAÇÃO ---
    const nextStep = useCallback(() => {
        setStep(prevStep => {
            if (prevStep === 1) {
                const currentErrors = {};
                let isValid = true;
                const { nome, email, telefone } = formData.dadosPessoais;

                if (!nome || !nome.trim()) {
                    currentErrors.nome = 'Nome é obrigatório.';
                    isValid = false;
                }
                if (!email || !email.trim()) {
                    currentErrors.email = 'E-mail é obrigatório.';
                    isValid = false;
                }
                if (!telefone || !telefone.trim()) {
                    currentErrors.telefone = 'Telefone é obrigatório.';
                    isValid = false;
                }

                if (!isValid) {
                    setErrors(prev => ({ ...prev, dadosPessoais: currentErrors }));
                    return prevStep;
                }
                // Limpa erros da etapa se estiver válido
                setErrors(prev => ({ ...prev, dadosPessoais: {} }));
            }
            return prevStep + 1;
        });
    }, [formData.dadosPessoais]);

    const prevStep = useCallback(() => setStep(prevStep => prevStep - 1), []);

    // --- SUBMISSÃO ---
    const handleSubmit = useCallback((event) => {
        event.preventDefault();

        if (step !== 3) {
            nextStep();
            return;
        }

        const newErrors = { experiencia: [] };
        let isValid = true;

        formData.experiencia.forEach(item => {
            const itemErrors = {};
            if (!item.empresa.trim()) { itemErrors.empresa = 'Empresa é obrigatória.'; isValid = false; }
            if (!item.cargo.trim()) { itemErrors.cargo = 'Cargo é obrigatório.'; isValid = false; }
            if (!item.inicio_exp.trim()) { itemErrors.inicio_exp = 'Data de início é obrigatória.'; isValid = false; }
            newErrors.experiencia.push(itemErrors);
        });

        setErrors(newErrors);

        if (!isValid) return;

        console.log('Dados Finais do Currículo:', formData);
        setStep(4);
        setShowDownloadLink(true);
    }, [step, formData, nextStep]);

    return {
        step,
        showDownloadLink,
        formData,
        errors,
        handleChange,
        handleRedesSociaisChange,
        addFormacao,
        removeFormacao,
        handleFormacaoChange,
        addExperiencia,
        removeExperiencia,
        handleExperienciaChange,
        nextStep,
        prevStep,
        handleSubmit
    };
};

export default useCreateResume;
